import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './type';

const reducers = {
  setScheduleList: (state: IRootState, action: PayloadAction<IRootState['scheduleList']>) => ({
    ...state,
    scheduleList: action.payload,
  }),
  setSelectedShiftDate: (state: IRootState, action: PayloadAction<IRootState['selectedShiftDate']>) => ({
    ...state,
    selectedShiftDate: action.payload,
  }),
  setSelectedScheduleShift: (state: IRootState, action: PayloadAction<IRootState['selectedScheduleShift']>) => ({
    ...state,
    selectedScheduleShift: action.payload,
  }),
  setIsOpenDeleteShiftDialog: (state: IRootState, action: PayloadAction<IRootState['isOpenDeleteShiftDialog']>) => ({
    ...state,
    isOpenDeleteShiftDialog: action.payload,
  }),
  setIsOpenDeleteTimeOffDialog: (state: IRootState, action: PayloadAction<IRootState['isOpenDeleteShiftDialog']>) => ({
    ...state,
    isOpenDeleteTimeOffDialog: action.payload,
  }),
  setIsOpenDayOffNav: (state: IRootState, action: PayloadAction<IRootState['isOpenDayOffNav']>) => ({
    ...state,
    isOpenDayOffNav: action.payload,
  }),
  setIsDisplayPublishBtn: (state: IRootState, action: PayloadAction<IRootState['isDisplayPublishBtn']>) => ({
    ...state,
    isDisplayPublishBtn: action.payload,
  }),
  setTimeOffs: (state: IRootState, action: PayloadAction<IRootState['timeOffs']>) => ({
    ...state,
    timeOffs: action.payload,
  }),
  setIsOpenBulkDialog: (state: IRootState, action: PayloadAction<IRootState['isOpenBulkDialog']>) => ({
    ...state,
    isOpenBulkDialog: action.payload,
  }),
  setSelectedShiftMember: (state: IRootState, action: PayloadAction<IRootState['selectedShiftMember']>) => ({
    ...state,
    selectedShiftMember: action.payload,
  }),
  setSelectedLocationId: (state: IRootState, action: PayloadAction<IRootState['selectedLocationId']>) => ({
    ...state,
    selectedLocationId: action.payload,
  }),
  setSelectedStatus: (state: IRootState, action: PayloadAction<IRootState['selectedStatus']>) => ({
    ...state,
    selectedStatus: action.payload,
  }),
  setIsOpenShiftNotesNav: (state: IRootState, action: PayloadAction<IRootState['isOpenShiftNotesNav']>) => ({
    ...state,
    isOpenShiftNotesNav: action.payload,
  }),
  setIsOpenCopyShiftsNav: (state: IRootState, action: PayloadAction<IRootState['isOpenCopyShiftsNav']>) => ({
    ...state,
    isOpenCopyShiftsNav: action.payload,
  }),
};

export {
  reducers,
};
